export default {"src":"/_next/static/media/training.dc1591f7.svg","height":50,"width":51,"blurWidth":0,"blurHeight":0};